import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICategoryResource, ICategoryTranslationList } from "../types";

export type ICategoryTranslationListQueryParameters = {
    category: RelationalValue<ICategoryResource>;
};

export type ICategoryTranslationListQueryResult = ICategoryTranslationList;

export const categoryTranslationListQuery: IApiQueryFunction<ICategoryTranslationListQueryParameters> = ({
    category,
}) => {
    if (!category) {
        return;
    }

    return {
        method: "GET",
        url: `/categories/${mapRelationalValue(category)}/translations`,
    };
};

export const useCategoryTranslationListQuery = createApiQueryHook<
    ICategoryTranslationListQueryParameters,
    ICategoryTranslationListQueryResult
>(categoryTranslationListQuery);
